import { ChromeReaderModeOutlined } from "@mui/icons-material";
import { Button } from "@mui/material";

interface Props {
  onClick: (e: React.MouseEvent) => void;
}

const TableDrawerButton = (props: Props) => {
  return (
    <Button
      variant="tertiary"
      endIcon={<ChromeReaderModeOutlined />}
      className="drawerButton"
      onClick={props.onClick}
      sx={{
        minWidth: "unset",
        backgroundColor: "white",
        "&:hover": { backgroundColor: "#e2edee" },
      }}
    >
      Open
    </Button>
  );
};

export { TableDrawerButton };
